/*
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-10-25 11:11:59
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-10-25 11:20:32
 * @FilePath: /genetron-web/genetron-h5/src/api/order.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { get, post } from "@/axios/http";
/** 订单退款接口 */
// const sendRequest = (data) => post("https://brave.genetroncare.com/brave/http/sendRequest", data);
const sendRequest = (data) => post(process.env.VUE_APP_API_BASE_URL+"/brave/http/sendRequest", data);

// const sendRequest = (data) => post("http://172.20.7.168:9093/brave/http/sendRequest", data);
// const uploadFileMore = (data) => post("https://brave.genetroncare.com/brave/http/uploadFileMore", data);
const uploadFileMore = (data) => post(process.env.VUE_APP_API_BASE_URL+"/brave/http/uploadFileMore", data);
// const zxDetail = data => get('/consult/getDetail',data);

/** 订单发票接口 */
// const sendInvoice = (data) => post("http://172.20.8.97:9090/brave/http/invoice/selectInvoiceByOrderCodeNew", data);   //根据订单号查询订单详情/
// const zxDetail = data => get('/consult/getDetail',data);

export { sendRequest,uploadFileMore};
